module.exports = "/_next/static/images/je-6ab0861417269eb87fc430130668527d.svg";